<template>
  <Teleport v-if="enabled" to="#bk-blokkli-item-actions-dropdown">
    <div>
      <h3>{{ title }}</h3>
      <slot />
    </div>
  </Teleport>
</template>

<script setup>
import { computed, useBlokkli, onMounted, onBeforeUnmount } from "#imports";
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  enabled: { type: Boolean, required: true }
});
const { eventBus } = useBlokkli();
const isRendering = computed(() => props.enabled);
onMounted(() => {
  eventBus.emit("plugin:mount", {
    type: "ItemDropdown",
    id: props.id,
    isRendering
  });
});
onBeforeUnmount(() => {
  eventBus.emit("plugin:unmount", {
    type: "ItemDropdown",
    id: props.id
  });
});
</script>

<script>
export default {
  name: "PluginItemDropdown"
};
</script>
